export const NOTE_PRESETS = [
  { text: 'Hospitalised', icon: 'mdi-bed-empty' },
  { text: 'Followed Up', icon: 'mdi-check-bold' },
  { text: 'Medication changed', icon: 'mdi-pill' },
  { text: 'Flare-up', icon: 'mdi-reload-alert' },
]
